module.exports = __webpack_public_path__ + "img/ap-mockup2.e4526dfd.jpg";